import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { Button, Icon } from "semantic-ui-react";
import { toast } from "react-toastify";
import { changePageScalePrepare } from "../../../../app/annots/annotSlice";
import { downloadPdf } from "../../../../app/common/util/util";
import { openModal } from "../../../../app/common/modals/modalSlice";
import { updateDocInDb } from "../../../../app/firestore/firestoreService";
import { toggleCommentsVisibility } from "../../docComments/docCommentsSlice";
import { hasCommentPermission } from "../../docComments/docCommentsUtils";

export default function DocViewActionButtons() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { doc } = useSelector((state) => state.doc);
  const { transaction } = useSelector((state) => state.transaction);
  const { currentUserProfile } = useSelector((state) => state.profile);
  const { pageScalePrepare } = useSelector((state) => state.annot);
  const { commentsVisible } = useSelector((state) => state.docComments);
  const isMobile = useMediaQuery({ query: "(max-width:1026px)" });
    // const isMobile = useMediaQuery({ query: "(max-width:768px)" });
  const isPhone = useMediaQuery({ query: "(max-width:570px)" });

  function closeDocument() {
    navigate(`/transactions/${transaction.id}/documents`);
  }

  async function handleDownload() {
    downloadPdf(doc, transaction, currentUserProfile);
  }

  async function handleSigningStatus() {
    try {
      const newStatus = doc.signingComplete === true ? false : true;
      await updateDocInDb(
        doc.id,
        {
          signingComplete: newStatus,
        },
        true
      );
      toast.success("Signing status updated");
    } catch (error) {
      toast.error(error.message);
    } finally {
    }
  }

  function handleZoomIn() {
    if (pageScalePrepare < 4) {
      dispatch(changePageScalePrepare(pageScalePrepare * 1.25));
    }
  }

  function handleZoomOut() {
    if (pageScalePrepare > 0.5) {
      dispatch(changePageScalePrepare(pageScalePrepare / 1.25));
    }
  }

  // Check if user has permission to manage comments
  const canManageComments = hasCommentPermission(currentUserProfile, isPhone);

  function handleToggleComments() {
    dispatch(toggleCommentsVisibility());
  }

  function handleCommentHistory() {
    dispatch(
      openModal({
        modalType: "DocCommentHistoryModal",
        modalProps: {},
      })
    );
  }

  return (
    <>
      <div
        className="large horizontal padding background-white"
        style={{
          top: "auto",
          bottom: "0",
          position: "fixed",
          width: "100%",
          height: "80px",
          borderTop: "1px solid #e8e8e8",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            float: "left",
          }}
        >
          <Button
            icon="download"
            onClick={() => handleDownload()}
            style={{ marginRight: "24px", ...(isMobile && { padding: "8px" }) }}
            content={isMobile ? "" : "Download"}
          />
          <Icon
            size="large"
            color="grey"
            name="minus circle"
            onClick={() => handleZoomOut()}
            style={{ cursor: "pointer" }}
          />
          <p
            className="zero bottom margin"
            style={{
              marginLeft: "3px",
              marginRight: "6px",
              fontWeight: "bold",
            }}
          >
            {Math.round(pageScalePrepare * 100)}%
          </p>
          <Icon
            size="large"
            color="grey"
            name="plus circle"
            onClick={() => handleZoomIn()}
            style={{ cursor: "pointer" }}
          />
        </div>
        <div
          className="large right margin"
          style={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            float: "right",
          }}
        >
          {canManageComments && (
            <>
              <Button
                icon={commentsVisible ? "eye slash" : "eye"}
                content={isMobile ? "" : (commentsVisible ? "Hide Comments" : "Show Comments")}
                onClick={handleToggleComments}
                style={{ marginRight: "10px", ...(isMobile && { padding: "8px" }) }}
                color={commentsVisible ? "orange" : undefined}
              />
              <Button
                icon="history"
                content={isMobile ? "" : "Comment History"}
                onClick={handleCommentHistory}
                style={{ marginRight: "10px", ...(isMobile && { padding: "8px" }) }}
              />
            </>
          )}
          <Button
            icon={doc.signingComplete === true ? "undo" : "check circle"}
            onClick={() => handleSigningStatus()}
            content={
              isMobile
                ? ""
                : doc.signingComplete === true
                ? "Undo Signing Complete"
                : "Mark Signing Complete"
            }
            style={{ marginRight: "10px", ...(isMobile && { padding: "8px" }) }}
          />
          <Button
            primary
            icon="close"
            onClick={() => closeDocument()}
            content={isMobile ? "" : "Close"}
            style={{ marginRight: "10px", ...(isMobile && { padding: "8px" }) }}
          />
        </div>
      </div>
    </>
  );
}
